(() => {
  const SpeechRecognition =
    window.SpeechRecognition ||
    window.webkitSpeechRecognition;

  if (!SpeechRecognition) {
    return;
  }

  const LANGUAGE_MAP = {
    el: 'el-GR',
    en: 'en-GB',
    de: 'de-DE',
    fr: 'fr-FR',
    it: 'it-IT',
    es: 'es-ES',
    nl: 'nl-NL',
    pt: 'pt-PT',
    pl: 'pl-PL',
    sv: 'sv-SE',
    da: 'da-DK',
    fi: 'fi-FI',
    ro: 'ro-RO',
    sl: 'sl-SI',
    et: 'et-EE',
    lv: 'lv-LV',
    lt: 'lt-LT',
    cs: 'cs-CZ',
    sk: 'sk-SK',
    hu: 'hu-HU',
    bg: 'bg-BG',
    hr: 'hr-HR'
  };

  const LANGUAGE_ALIASES = {
    el: ['el', 'el-gr', 'ελληνικά', 'ελληνικα', 'greek'],
    en: ['en', 'en-gb', 'en-us', 'english'],
    de: ['de', 'de-de', 'deutsch', 'german'],
    fr: ['fr', 'fr-fr', 'français', 'francais', 'french'],
    it: ['it', 'it-it', 'italiano', 'italian'],
    es: ['es', 'es-es', 'español', 'espanol', 'spanish'],
    nl: ['nl', 'nl-nl', 'nederlands', 'dutch'],
    pt: ['pt', 'pt-pt', 'português', 'portugues', 'portuguese'],
    pl: ['pl', 'pl-pl', 'polski', 'polish'],
    sv: ['sv', 'sv-se', 'svenska', 'swedish'],
    da: ['da', 'da-dk', 'dansk', 'danish'],
    fi: ['fi', 'fi-fi', 'suomi', 'finnish'],
    ro: ['ro', 'ro-ro', 'română', 'romana', 'romanian'],
    sl: ['sl', 'sl-si', 'slovenščina', 'slovenscina', 'slovenian'],
    et: ['et', 'et-ee', 'eesti', 'estonian'],
    lv: ['lv', 'lv-lv', 'latviešu', 'latviesu', 'latvian'],
    lt: ['lt', 'lt-lt', 'lietuvių', 'lietuviu', 'lithuanian'],
    cs: ['cs', 'cs-cz', 'čeština', 'cestina', 'czech'],
    sk: ['sk', 'sk-sk', 'slovenčina', 'slovencina', 'slovak'],
    hu: ['hu', 'hu-hu', 'magyar', 'hungarian'],
    bg: ['bg', 'bg-bg', 'български', 'bulgarian'],
    hr: ['hr', 'hr-hr', 'hrvatski', 'croatian']
  };

  const LABELS = {
    el: {
      search: 'Φωνητική αναζήτηση',
      listening: 'Ακούω…'
    },

    en: {
      search: 'Search by voice',
      listening: 'Listening…'
    },

    de: {
      search: 'Sprachsuche',
      listening: 'Ich höre zu…'
    },

    fr: {
      search: 'Recherche vocale',
      listening: 'Écoute…'
    },

    it: {
      search: 'Ricerca vocale',
      listening: 'In ascolto…'
    },

    es: {
      search: 'Búsqueda por voz',
      listening: 'Escuchando…'
    },

    nl: {
      search: 'Zoeken met stem',
      listening: 'Luisteren…'
    },

    pt: {
      search: 'Pesquisa por voz',
      listening: 'A ouvir…'
    },

    pl: {
      search: 'Wyszukiwanie głosowe',
      listening: 'Słucham…'
    }
  };

  const SVG_MIC = `
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3Z"></path>
      <path d="M19 10v1a7 7 0 0 1-14 0v-1"></path>
      <path d="M12 18v4"></path>
      <path d="M8 22h8"></path>
    </svg>
  `;

  function normalizeText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/_/g, '-')
      .replace(/\s+/g, ' ');
  }

  function baseLanguageFromValue(value) {
    const normalized =
      normalizeText(value);

    if (!normalized) {
      return '';
    }

    const exactLocale =
      normalized.match(
        /^([a-z]{2})(?:-[a-z]{2})?$/i
      );

    if (
      exactLocale &&
      LANGUAGE_MAP[exactLocale[1]]
    ) {
      return exactLocale[1];
    }

    for (
      const [base, aliases]
      of Object.entries(
        LANGUAGE_ALIASES
      )
    ) {
      for (
        const alias of aliases
      ) {
        const normalizedAlias =
          normalizeText(alias);

        if (
          normalized ===
          normalizedAlias
        ) {
          return base;
        }

        /*
         * Only use partial matching
         * for actual language names,
         * not 2-letter codes.
         */
        if (
          normalizedAlias.length > 2 &&
          normalized.includes(
            normalizedAlias
          )
        ) {
          return base;
        }
      }
    }

    return '';
  }

  function detectLanguageFromSwitcher() {
    /*
     * Transtore active/current language.
     */

    const selectors = [
      '.ts-switcher-expand__select.ts-language .ts-language__name',
      '.ts-language .ts-language__name',
      '.ts-language__name',
      '.ts-language .ts-list-item.ts-list-item__active .ts-list-item__name',
      '.ts-switcher-expand__select.ts-language .ts-list-item.ts-list-item__active .ts-list-item__name'
    ];

    for (
      const selector of selectors
    ) {
      let elements = [];

      try {
        elements =
          document.querySelectorAll(
            selector
          );
      } catch (error) {
        continue;
      }

      for (
        const element of elements
      ) {
        const text =
          element.textContent ||
          element.getAttribute(
            'aria-label'
          ) ||
          element.getAttribute(
            'title'
          ) ||
          element.getAttribute(
            'data-language'
          ) ||
          element.getAttribute(
            'data-locale'
          ) ||
          '';

        const base =
          baseLanguageFromValue(
            text
          );

        if (base) {
          return base;
        }
      }
    }

    return '';
  }

  function detectLanguageFromUrl() {
    try {
      const url =
        new URL(
          window.location.href
        );

      const queryCandidates = [
        url.searchParams.get(
          'locale'
        ),
        url.searchParams.get(
          'language'
        ),
        url.searchParams.get(
          'lang'
        )
      ];

      for (
        const candidate
        of queryCandidates
      ) {
        const base =
          baseLanguageFromValue(
            candidate
          );

        if (base) {
          return base;
        }
      }

      const firstPathPart =
        url.pathname
          .split('/')
          .filter(Boolean)[0];

      const pathBase =
        baseLanguageFromValue(
          firstPathPart
        );

      if (pathBase) {
        return pathBase;
      }
    } catch (error) {}

    return '';
  }

  function detectLanguageFromStorage() {
    const keyPattern =
      /lang|locale|translat|transtore/i;

    /*
     * localStorage
     */

    try {
      for (
        let index = 0;
        index < localStorage.length;
        index += 1
      ) {
        const key =
          localStorage.key(
            index
          );

        if (
          !key ||
          !keyPattern.test(key)
        ) {
          continue;
        }

        const rawValue =
          localStorage.getItem(
            key
          );

        const directBase =
          baseLanguageFromValue(
            rawValue
          );

        if (directBase) {
          return directBase;
        }

        try {
          const parsed =
            JSON.parse(
              rawValue
            );

          const serialized =
            JSON.stringify(
              parsed
            );

          const parsedBase =
            baseLanguageFromValue(
              serialized
            );

          if (parsedBase) {
            return parsedBase;
          }
        } catch (error) {}
      }
    } catch (error) {}

    /*
     * Cookies
     */

    try {
      const cookies =
        document.cookie
          .split(';')
          .map(
            (item) =>
              item.trim()
          );

      for (
        const cookie of cookies
      ) {
        const separatorIndex =
          cookie.indexOf('=');

        if (
          separatorIndex === -1
        ) {
          continue;
        }

        const key =
          cookie.slice(
            0,
            separatorIndex
          );

        const value =
          decodeURIComponent(
            cookie.slice(
              separatorIndex + 1
            )
          );

        if (
          !keyPattern.test(key)
        ) {
          continue;
        }

        const base =
          baseLanguageFromValue(
            value
          );

        if (base) {
          return base;
        }
      }
    } catch (error) {}

    return '';
  }

  function getBaseLanguage() {
    /*
     * 1. Transtore CURRENT
     * visible language.
     */

    const transtoreLanguage =
      detectLanguageFromSwitcher();

    if (transtoreLanguage) {
      return transtoreLanguage;
    }

    /*
     * 2. Locale from URL.
     */

    const urlLanguage =
      detectLanguageFromUrl();

    if (urlLanguage) {
      return urlLanguage;
    }

    /*
     * 3. Transtore/local storage.
     */

    const storedLanguage =
      detectLanguageFromStorage();

    if (storedLanguage) {
      return storedLanguage;
    }

    /*
     * 4. Liquid-provided locale.
     */

    const liquidLocale =
      baseLanguageFromValue(
        window.athensVoiceLocale
      );

    if (liquidLocale) {
      return liquidLocale;
    }

    /*
     * 5. HTML lang.
     */

    const htmlLanguage =
      baseLanguageFromValue(
        document
          .documentElement
          .lang
      );

    if (htmlLanguage) {
      return htmlLanguage;
    }

    /*
     * 6. Shopify locale.
     */

    const shopifyLanguage =
      baseLanguageFromValue(
        window.Shopify &&
        window.Shopify.locale
      );

    if (shopifyLanguage) {
      return shopifyLanguage;
    }

    /*
     * 7. Browser fallback.
     */

    return (
      baseLanguageFromValue(
        navigator.language
      ) ||
      'en'
    );
  }

  function getRecognitionLanguage() {
    const baseLanguage =
      getBaseLanguage();

    return (
      LANGUAGE_MAP[
        baseLanguage
      ] ||
      navigator.language ||
      'en-GB'
    );
  }

  function getLabels() {
    return (
      LABELS[
        getBaseLanguage()
      ] ||
      LABELS.en
    );
  }

  function cleanTranscript(text) {
    return String(
      text || ''
    )
      .trim()
      .replace(
        /\s+/g,
        ' '
      );
  }

  function injectStyles() {
    if (
      document.getElementById(
        'athens-voice-search-styles'
      )
    ) {
      return;
    }

    const style =
      document.createElement(
        'style'
      );

    style.id =
      'athens-voice-search-styles';

    style.textContent = `
      .athens-voice-search-button {
        position: absolute;
        z-index: 4;

        display: inline-flex;
        align-items: center;
        justify-content: center;

        width: 34px;
        height: 34px;

        margin: 0;
        padding: 0;

        border: 0;
        border-radius: 50%;

        background: transparent;
        color: inherit;

        font: inherit;
        line-height: 1;

        cursor: pointer;

        opacity: 0.55;

        transition:
          opacity 0.15s ease,
          background-color 0.15s ease,
          transform 0.15s ease;
      }

      .athens-voice-search-button:hover {
        opacity: 0.95;

        background-color:
          rgba(
            127,
            127,
            127,
            0.08
          );
      }

      .athens-voice-search-button:focus-visible {
        outline:
          2px solid currentColor;

        outline-offset: 2px;
      }

      .athens-voice-search-button svg {
        display: block;

        width: 18px;
        height: 18px;

        fill: none;
        stroke: currentColor;

        stroke-width: 1.8;
        stroke-linecap: round;
        stroke-linejoin: round;

        pointer-events: none;
      }

      .athens-voice-search-button.is-listening {
        opacity: 1;

        background-color:
          rgba(
            127,
            127,
            127,
            0.10
          );
      }

      .athens-voice-search-button.is-listening svg {
        animation:
          athensVoicePulse
          0.9s
          ease-in-out
          infinite;
      }

      @keyframes athensVoicePulse {
        0%,
        100% {
          transform:
            scale(1);

          opacity: 1;
        }

        50% {
          transform:
            scale(0.86);

          opacity: 0.5;
        }
      }

      @media (
        prefers-reduced-motion:
        reduce
      ) {
        .athens-voice-search-button,
        .athens-voice-search-button svg {
          transition: none;

          animation:
            none !important;
        }
      }
    `;

    document.head
      .appendChild(
        style
      );
  }

  function setupComponent(
    component
  ) {
    if (!component) {
      return;
    }

    if (
      component.dataset
        .voiceSearchReady ===
      'true'
    ) {
      return;
    }

    const input =
      component.querySelector(
        'input[type="search"]'
      );

    const button =
      component.querySelector(
        '.athens-voice-search-button'
      );

    if (
      !input ||
      !button
    ) {
      return;
    }

    component.dataset
      .voiceSearchReady =
      'true';

    /*
     * Speech Recognition.
     */

    const recognition =
      new SpeechRecognition();

    recognition.continuous =
      true;

    /*
     * Important:
     * interimResults=true means
     * the text can appear while
     * the customer is speaking.
     */

    recognition.interimResults =
      true;

    recognition.maxAlternatives =
      1;

    let keepListening =
      false;

    let speechEndTimer =
      null;
      let transcriptParts = [];

    function updateButtonLabels() {
      const labels =
        getLabels();

      const label =
        keepListening
          ? labels.listening
          : labels.search;

      button.setAttribute(
        'aria-label',
        label
      );

      button.setAttribute(
        'title',
        label
      );

      button.setAttribute(
        'aria-pressed',
        keepListening
          ? 'true'
          : 'false'
      );
    }

    function setListeningState(
      state
    ) {
      button.classList.toggle(
        'is-listening',
        state
      );

      updateButtonLabels();
    }

    updateButtonLabels();

    /*
     * Mic click.
     */

    button.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        /*
         * Second click =
         * manually stop.
         */

        if (keepListening) {
          keepListening =
            false;

          if (speechEndTimer) {
            clearTimeout(
              speechEndTimer
            );

            speechEndTimer =
              null;
          }

          try {
            recognition.stop();
          } catch (error) {}

          setListeningState(
            false
          );

          return;
        }

        /*
         * Detect the currently
         * selected customer language
         * every time the mic
         * is clicked.
         */

        const detectedLanguage =
          getRecognitionLanguage();

        recognition.lang =
          detectedLanguage;

        /*
         * Debug value.
         */

        window
          .__athensVoiceLanguage =
          detectedLanguage;

        keepListening =
          true;

        updateButtonLabels();

        try {
          transcriptParts = [];
          recognition.start();
        } catch (error) {
          keepListening =
            false;

          setListeningState(
            false
          );

          console.warn(
            'Voice search could not start:',
            error
          );
        }
      }
    );

    recognition.addEventListener(
      'start',
      () => {
        setListeningState(
          true
        );
      }
    );

    recognition.addEventListener(
      'speechstart',
      () => {
        if (speechEndTimer) {
          clearTimeout(
            speechEndTimer
          );

          speechEndTimer =
            null;
        }
      }
    );

    /*
     * Stop around 1.5 seconds
     * after user finishes
     * speaking.
     */

    recognition.addEventListener(
      'speechend',
      () => {
        if (speechEndTimer) {
          clearTimeout(
            speechEndTimer
          );
        }

        speechEndTimer =
          setTimeout(
            () => {
              keepListening =
                false;

              try {
                recognition.stop();
              } catch (error) {}

              setListeningState(
                false
              );
            },
            1500
          );
      }
    );

    /*
     * Put the voice transcript
     * immediately into the Athens
     * search field.
     *
     * This works with both interim
     * and final SpeechRecognition
     * results.
     */

    recognition.addEventListener(
  'result',
  (event) => {
    /*
     * Store each SpeechRecognition
     * result by its own index.
     *
     * Interim results replace the
     * previous version instead of
     * being appended to it.
     */
    for (
      let i = event.resultIndex;
      i < event.results.length;
      i += 1
    ) {
      const result =
        event.results[i];

      if (
        !result ||
        !result[0]
      ) {
        continue;
      }

      const part =
        cleanTranscript(
          result[0].transcript
        );

      transcriptParts[i] =
        part;
    }

    /*
     * Merge recognition segments
     * without repeating overlapping
     * words or cumulative interim
     * transcripts.
     */
    const mergeParts = (
      current,
      next
    ) => {
      current =
        cleanTranscript(current);

      next =
        cleanTranscript(next);

      if (!current) {
        return next;
      }

      if (!next) {
        return current;
      }

      const currentLower =
        current.toLowerCase();

      const nextLower =
        next.toLowerCase();

      /*
       * Same phrase.
       */
      if (
        currentLower ===
        nextLower
      ) {
        return current;
      }

      /*
       * Example:
       *
       * current:
       * "κρεμαστό"
       *
       * next:
       * "κρεμαστό φωτιστικό"
       *
       * Keep the newer,
       * more complete phrase.
       */
      if (
        nextLower.startsWith(
          currentLower
        )
      ) {
        return next;
      }

      /*
       * Example:
       *
       * current:
       * "κρεμαστό φωτιστικό"
       *
       * next:
       * "κρεμαστό"
       *
       * Do not add it again.
       */
      if (
        currentLower.includes(
          nextLower
        )
      ) {
        return current;
      }

      if (
        nextLower.includes(
          currentLower
        )
      ) {
        return next;
      }

      /*
       * Word-overlap protection.
       *
       * Example:
       *
       * "κρεμαστό φωτιστικό"
       * +
       * "φωτιστικό οροφής"
       *
       * =
       * "κρεμαστό φωτιστικό οροφής"
       */
      const currentWords =
        current.split(/\s+/);

      const nextWords =
        next.split(/\s+/);

      const maxOverlap =
        Math.min(
          currentWords.length,
          nextWords.length
        );

      for (
        let size = maxOverlap;
        size > 0;
        size -= 1
      ) {
        const currentEnd =
          currentWords
            .slice(-size)
            .join(' ')
            .toLowerCase();

        const nextStart =
          nextWords
            .slice(0, size)
            .join(' ')
            .toLowerCase();

        if (
          currentEnd ===
          nextStart
        ) {
          return [
            ...currentWords,
            ...nextWords.slice(size)
          ].join(' ');
        }
      }

      return `${current} ${next}`;
    };

    let transcript = '';

    transcriptParts
      .filter(Boolean)
      .forEach((part) => {
        transcript =
          mergeParts(
            transcript,
            part
          );
      });

    transcript =
      cleanTranscript(
        transcript
      );

    if (!transcript) {
      return;
    }

    /*
     * Show speech immediately.
     */
    input.value =
      transcript;

    /*
     * Trigger Athens Smart Search.
     */
    input.dispatchEvent(
      new Event(
        'input',
        {
          bubbles: true
        }
      )
    );

    try {
      input.setSelectionRange(
        input.value.length,
        input.value.length
      );
    } catch (error) {}
  }
);

    recognition.addEventListener(
      'end',
      () => {
        keepListening =
          false;

        if (speechEndTimer) {
          clearTimeout(
            speechEndTimer
          );

          speechEndTimer =
            null;
        }

        setListeningState(
          false
        );
      }
    );

    recognition.addEventListener(
      'error',
      (event) => {
        keepListening =
          false;

        if (speechEndTimer) {
          clearTimeout(
            speechEndTimer
          );

          speechEndTimer =
            null;
        }

        setListeningState(
          false
        );

        if (
          event.error ===
            'no-speech' ||
          event.error ===
            'aborted'
        ) {
          return;
        }

        console.warn(
          `Voice search error: ${event.error}`
        );
      }
    );
  }

  function initialiseVoiceSearch(
    root = document
  ) {
    injectStyles();

    const components =
      root.querySelectorAll
        ? root.querySelectorAll(
            'predictive-search'
          )
        : [];

    components.forEach(
      (component) => {
        setupComponent(
          component
        );
      }
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initialiseVoiceSearch();
      }
    );
  } else {
    initialiseVoiceSearch();
  }

  /*
   * Run again after full page load
   * in case the theme renders
   * additional search components.
   */

  window.addEventListener(
    'load',
    () => {
      initialiseVoiceSearch();
    }
  );

  /*
   * Shopify Theme Editor support.
   */

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialiseVoiceSearch(
        event.target
      );
    }
  );
})();